const value = {
    systemSpecificationsTitle: 'Характеристики АС',
    systemSpecificationsDes:
      'Содержит перечень разделов и значения, которые могут быть выбраны пользователем в каждом разделе при заполнении анкеты на АС',
    categories: 'Категории',
    categoriesOfSpecification: 'Категории',
    values: 'Значения',
    valuesOfSpecification: 'Значения характеристик',
    requirementsExecutorTitle: 'Исполнители требований',
    requirementsExecutorDes:
      'Данная характеристика выбирается при создании анкеты для АС и используется для скрытия части полей или требований от внешних разработчиков.',
    executors: 'Исполнители',
    integrationsTitle: 'Интеграции',
    integrationsDes: 'Содержит перечень соединений с JIRA, Active Directory и Почтовой системой',
    integrationsDesASM: 'Настройка соединений с Active Directory',
    mail: 'Почта',
    loggingTitle: 'Журналирование',
    loggingDes: 'Содержит журнал событий',
    eventLog: 'Журнал событий',
    templatesTitle: 'Шаблоны анкет',
    templatesDes: 'Содержит перечень шаблонов анкет',
    userManagementTitle: 'Управление пользователями',
    userManagementDes: 'Содержит перечень пользователей системы',
    users: 'Пользователи',
    projectRoles: 'Проектные роли',
    systemRoles: 'Системные роли',
    ssoPage: 'SSO',
    ssoProvider: 'Список провайдеров SSO',
  };

export default value;
